import { render } from "./Deals.vue?vue&type=template&id=0d8ce8dc&ts=true"
import script from "./Deals.vue?vue&type=script&lang=ts"
export * from "./Deals.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__